const pendoEndpoint = "https://app.pendo.io/api/v1/";

const pendoConsts = {
  endpoint: pendoEndpoint,
  aggregationEndpoint: pendoEndpoint + "aggregation",
  integrationKey: "314cdd49-51ac-4018-6fdc-f41bb7b18b29.us",
  pageId: "nHDOj5qUIq2v2KI1wSOAK4U4JU4",
  selectEventId: "gXcdF-bm40kecf5Z7GcPN5Vsqdc",
  closeEventId: "YB7q1Y8LhKH6ecIIKkFqN8MHwBM",
};

export default pendoConsts;
